export default __webpack_public_path__ + "static/media/phone.d6e07718.svg";